// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"64":"c15131fcbc81fd82","413":"a21dca813f55f9c6","588":"e0d2d7cf8bc27db6","627":"d507d09fe5142bc8","898":"25a752084c69c538"}[chunkId] + ".js";
};